import _ from "lodash";

const t = (str) => _.trimEnd(str || "", "/");

export const BaseAddress = {
  Api: t(process.env.REACT_APP_API_URL),
  Auth: t(process.env.REACT_APP_AUTH_URL),
  CcAdmin: t(process.env.REACT_APP_CCADMIN_URL),
  CubeJs: t(process.env.REACT_APP_CUBEJS_URL),
};
